<template>
  <div class="service-ctgy-group">
    <v-list>
      <v-list-item-group>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          @click="onServiceClick(item)"
        >
          <v-list-item-content>
            <div
              class="service-ctgy-group__item"
            >
              <div class="service-ctgy-group__img-container">
                <img
                  v-if="item.ImageUrls.length > 0"
                  :src="item.ImageUrls[0]"
                >
                <template v-else>
                  <img
                    src="../assets/image/product_default.png"
                  >
                </template>
              </div>
              <div class="service-ctgy-group__body">
                <div class="service-ctgy-group__title">
                  {{ item.ServiceTitle }}
                </div>
                <div class="service-ctgy-group__desc">
                  {{ item.ServiceDesc }}
                </div>
              </div>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    typeParent: {
      type: Number,
      default: 0
    },
    mainTypeName: {
      type: String,
      default: ''
    },
    tabName: {
      type: String,
      default: ''
    }
  },
  methods: {
    onServiceClick (item) {
      // 發送 GA 事件：{母分類Tab}_專館_{mainTypeName}_商品頁_{mainData.serviceTitle}
      this.$gaLogEvent('全部分類頁', `${this.tabName}_專館_${this.mainTypeName}_商品頁_${item.ServiceTitle}`)

      // 導航到服務詳情頁
      this.$router.push({ name: 'category-category-service', params: { category: this.typeParent, service: item.ServiceId } })
    }
  }
}
</script>
<style lang="scss" scoped>
  $ItemGap: 20px;
  .service-ctgy-group {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: $ItemGap;
    padding: 4px 0;

    &__item {
      display: flex;
      align-items: flex-start;
      gap: 8px;
    }

    &__img-container {
      width: 68px;
      height: 68px;
      display: grid;
      place-items: center;
      overflow: hidden;
      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
        border-radius: 4px;
      }
    }

    &__body {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }

    &__title {
      font-size: pxTorem(16px);
      margin-bottom: 2px;
    }

    &__desc {
      font-size: pxTorem(13px);
      color: $color-caption;
    }

    .v-list {
      padding-top: 0;
    }
  }

  .v-list-item {
    padding: $ItemGap/2;

    &__content {
      padding: 0;
    }
  }

  .v-item-group {
    display: flex;
    flex-direction: column;
  }
</style>
